import { skipDisabledSizeCategories } from "@/components/filter/filterHelpers";
import { FilterSection } from "@/components/filter/FilterSection";
import { CheckboxField } from "@/components/ui-components/CheckboxField";
import { DisabledMessage } from "@/components/ui-components/CheckboxField/CheckboxField";
import useFilterQuery from "@/hooks/useFilterQuery";

const FilterSizes = () => {
  const { sizes, selectedSizes, toggleSecondaryFilterItem } = useFilterQuery();

  const sizesEnabled = skipDisabledSizeCategories(sizes);

  const isChecked = (sizeId: string) => {
    return selectedSizes.includes(sizeId);
  };

  const disabledMessage: DisabledMessage = {
    title: "размер недоступен",
    body: "измените критерии поиска",
  };

  return (
    <FilterSection title="Размер" count={selectedSizes.length}>
      {sizesEnabled[0]?.sizes.map((size) => {
        const checked = isChecked(size.id);
        const toggleChecked = () => {
          toggleSecondaryFilterItem(size.id, "sizes");
        };
        return (
          <CheckboxField
            label={size.name}
            checked={checked}
            toggleChecked={toggleChecked}
            key={size.id}
            disabled={size.disabled}
            disabledMessage={disabledMessage}
          />
        );
      })}
    </FilterSection>
  );
};

export default FilterSizes;
